import React, { Component } from 'react';
import {
  AjudaContainer,
  Menu,
  Cercador,
  Cataleg,
  Fons,
  Navbar,
  FletxaNavbar,
  Llegenda,
  FletxaFons,
  FletxaLlegenda,
  FletxaMenu,
  FletxaCercador,
  FletxaCataleg,
  FletxaMesura,
  Mesura,
  Scale,
  ScaleFletxa,
  FletxaCurvaDiv,
  FletxaFav,
  Fav
} from './AjudaElements';
import Fletxa from '../../../images/Arrow.png';
import FletxaMini from '../../../images/Arrow3.png';
import FletxaCurva from '../../../images/fletxa-curva.png';
import FletxaLlarga from '../../../images/fletxa-llarga.png';
import { getTranslatedKey } from '../../Utils/TranslateUtils';
import { displayComponents } from '../../Utils/VisorsUtils';

export default class Ajuda extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <AjudaContainer
        id="AjudaContainer"
        ajudaOpen={this.props.ajudaOpen}
        onClick={() => this.props.toggleAjuda()}
        fontSizeEnabled={this.props.fontSizeEnabled}>
        <FletxaMenu>
          <img src={FletxaMini} class="fletxaMini" alt={getTranslatedKey('fletxa')} />
          <img src={FletxaLlarga} class="fletxaLlarga" alt={getTranslatedKey('fletxa')} />
        </FletxaMenu>
        <Menu>{getTranslatedKey('menu')}</Menu>
        {this.props.arrayLayers.length !== 0 && displayComponents.llegenda ? (
          <>
            <FletxaLlegenda>
              <img src={Fletxa} class="fletxa" alt={getTranslatedKey('fletxa')} />
              <img src={FletxaMini} class="fletxaMini" alt={getTranslatedKey('fletxa')} />
            </FletxaLlegenda>
            <Llegenda>{getTranslatedKey('llegenda')}</Llegenda>
          </>
        ) : null}
        {displayComponents.cerca && (
          <>
            <FletxaCercador>
              <img src={Fletxa} alt={getTranslatedKey('fletxa')} />
            </FletxaCercador>
            <FletxaCurvaDiv>
              <img src={FletxaCurva} class="curva" alt={getTranslatedKey('fletxa')} />
            </FletxaCurvaDiv>
            {displayComponents.cercaAvançada && (
              <Cercador>
                {getTranslatedKey('cerca')} <br /> {getTranslatedKey('cercaAvançada')}
              </Cercador>
            )}
          </>
        )}
        {displayComponents.cataleg && (
          <>
            <FletxaCataleg>
              <img src={FletxaMini} class="fletxaMini" alt={getTranslatedKey('fletxa')} />
            </FletxaCataleg>
            <Cataleg>{getTranslatedKey('cataleg')}</Cataleg>
          </>
        )}
        <FletxaFons fav={this.props.favList.length > 0}>
          <img src={FletxaMini} class="fletxaMini" alt={getTranslatedKey('fletxa')} />
        </FletxaFons>
        <Fons fav={this.props.favList.length > 0}>
          {getTranslatedKey('ubi')}
          <br />
          {displayComponents.selectorFons && getTranslatedKey('fons')}
          {this.props.favList.length > 0 && window.innerWidth < 930 && (
            <>
              <br />
              {getTranslatedKey('fav')}
            </>
          )}
        </Fons>
        {this.props.favList.length > 0 && (
          <>
            <FletxaFav>
              <img src={FletxaMini} class="fletxaMini" alt={getTranslatedKey('fletxa')} />
            </FletxaFav>
            <Fav>{getTranslatedKey('fav')}</Fav>
          </>
        )}
        <FletxaNavbar>
          <img src={FletxaLlarga} class="fletxaLlarga" alt={getTranslatedKey('fletxa')} />
        </FletxaNavbar>
        <Navbar>
          {displayComponents.descarrega && (
            <>
              {getTranslatedKey('gestion')} <br />
            </>
          )}
          {displayComponents.imprimir && (
            <>
              {getTranslatedKey('printText')} <br />
            </>
          )}
          {displayComponents.compartir && (
            <>
              {getTranslatedKey('share')} <br />
            </>
          )}
          {displayComponents.accessibilitat && (
            <>
              {getTranslatedKey('accessibilitat')}
              <br />
            </>
          )}
          {displayComponents.contact && (
            <>
              {getTranslatedKey('enviar')}
              <br />
            </>
          )}
          {displayComponents.ajuda && (
            <>
              {getTranslatedKey('help')}
              <br />
            </>
          )}
          {displayComponents.fullScreen && (
            <>
              {getTranslatedKey('fullScreen')}
              <br />
            </>
          )}
        </Navbar>
        {displayComponents.einesMesura && (
          <>
            <FletxaMesura>
              <img src={FletxaMini} class="fletxaMini" alt={getTranslatedKey('fletxa')} />
            </FletxaMesura>
            <Mesura>{getTranslatedKey('eines')}</Mesura>
          </>
        )}
        {displayComponents.escala && (
          <>
            <ScaleFletxa>
              <img src={FletxaMini} class="fletxaMini" alt={getTranslatedKey('fletxa')} />
            </ScaleFletxa>
            <Scale>
              {getTranslatedKey('scale')}
              {window.innerWidth > 464 && (
                <>
                  <br />
                  {getTranslatedKey('coordinates')}
                </>
              )}
            </Scale>
          </>
        )}
      </AjudaContainer>
    );
  }
}
